import styles from './Faq.module.scss';
import Link from 'next/link';
import { ORDERING_MEMEBER, PRODUCT_QUESTION } from '../../../commons/Constants';

export default function FaqPage() {
  return (
    <div className={styles.faqContainer}>
      <h1 className={styles.faqTitle}>Answers to Common Questions</h1>
      <h3 className={styles.faqSubTitle}>
        Can&apos;t find an answer - please{' '}
        <Link href="/support">
          <a className={styles.faqContactLink}>contact us</a>
        </Link>
        . We are happy to help.
      </h3>
      <h2 className={styles.faqSectionHeader}>Product</h2>
      <ul className={styles.faqQuestionContainer}>
        {PRODUCT_QUESTION?.map((item, key) => (
          <li key={key} className={styles.faqQuestionTitle}>
            {item.question}
            <h3 className={styles.faqQuestionAnswer}>{item.answer}</h3>
          </li>
        ))}
      </ul>
      <h2 className={styles.faqSectionHeader}>Ordering &amp; Membership</h2>
      <ul className={styles.faqQuestionContainer}>
        {ORDERING_MEMEBER?.map((item, key) => (
          <li key={key} className={styles.faqQuestionTitle}>
            {item.question}
            <h3 className={styles.faqQuestionAnswer}>{item.answer}</h3>
          </li>
        ))}
      </ul>
    </div>
  );
}
